<script context="module" lang="ts">
  import type { PageCollectionTheme } from '$lib/sanity/schemas';
  import { getContext } from 'svelte';

  export function useThemeSpacerMultiplier(theme?: PageCollectionTheme | null) {
    const contextTheme = getContext<PageCollectionTheme>('theme');
    const currentTheme = theme ?? contextTheme;

    return {
      mobile: Number(currentTheme?.general?.spacerMultiplierMobile ?? 1),
      desktop: Number(currentTheme?.general?.spacerMultiplierDesktop ?? 1)
    };
  }
</script>

<script lang="ts">
  import { setContext } from 'svelte';
  import merge from 'lodash/merge';
  import { adaptPageCollectionThemeToTwistTheme, themeStyleVars } from '$lib/pages/theme';
  import type { ColorPalette } from '$lib/sanity/schemas';

  export let palette: ColorPalette[] | undefined | null = [];
  export let theme: PageCollectionTheme | undefined | null = {};

  const baseTheme = getContext<PageCollectionTheme>('theme');
  const mergedTheme = merge({}, baseTheme, theme);
  setContext('theme', mergedTheme);

  const paletteVars =
    palette
      ?.map((color: ColorPalette) => `--theme-palette-${color._key}: ${color.hex};`)
      .join('') ?? '';
</script>

<div
  style={[
    paletteVars,
    themeStyleVars(theme ?? {}),
    themeStyleVars(adaptPageCollectionThemeToTwistTheme(theme ?? {}), '--twist-theme')
  ].join('')}
>
  <slot />
</div>
